import { Controller } from '@hotwired/stimulus'

// Debounced GHL contact search + inline result list.
//
// Markup:
//   <div data-controller="customer-link-picker"
//        data-customer-link-picker-search-url-value="/customer_links/search">
//     <input data-customer-link-picker-target="input" />
//     <input data-customer-link-picker-target="hidden" type="hidden" name="ghl_contact_id" />
//     <div data-customer-link-picker-target="results"></div>
//     <button data-customer-link-picker-target="submit" disabled>Link</button>
//   </div>
export default class extends Controller {
  static targets = ['input', 'hidden', 'results', 'submit']
  static values  = { searchUrl: String }

  connect() {
    this._debounce = null
  }

  onInput() {
    clearTimeout(this._debounce)
    // Clear the previously-chosen contact whenever the user retypes.
    this.hiddenTarget.value = ''
    if (this.hasSubmitTarget) this.submitTarget.disabled = true

    const q = this.inputTarget.value.trim()
    if (q.length < 2) {
      this.resultsTarget.innerHTML = ''
      return
    }

    this._debounce = setTimeout(() => this._fetch(q), 200)
  }

  async _fetch(q) {
    const url = `${this.searchUrlValue}?q=${encodeURIComponent(q)}`
    try {
      const res = await fetch(url, { headers: { Accept: 'application/json' } })
      if (!res.ok) return
      const rows = await res.json()
      this._render(rows)
    } catch (_) {
      /* swallow; transient */
    }
  }

  _render(rows) {
    if (rows.length === 0) {
      this.resultsTarget.innerHTML = `
        <div class="px-3 py-2 text-xs text-zinc-500">No matches.</div>`
      return
    }

    this.resultsTarget.innerHTML = rows.map((r, i) => `
      <button type="button"
              class="flex w-full flex-col items-start gap-0.5 border-b border-zinc-100 px-3 py-2 text-left text-xs hover:bg-zinc-50 last:border-b-0"
              data-action="click->customer-link-picker#choose"
              data-id="${r.id}"
              data-label="${this._escape(r.label)}"
              data-email="${this._escape(r.email || '')}">
        <span class="font-medium text-zinc-900">${this._escape(r.label)}</span>
        <span class="text-zinc-500">${this._escape(r.email || '—')}${r.utm_campaign ? ' · ' + this._escape(r.utm_campaign) : ''}</span>
      </button>
    `).join('')
  }

  choose(event) {
    const el = event.currentTarget
    this.hiddenTarget.value = el.dataset.id
    this.inputTarget.value = el.dataset.label + (el.dataset.email ? ` <${el.dataset.email}>` : '')
    this.resultsTarget.innerHTML = ''
    if (this.hasSubmitTarget) this.submitTarget.disabled = false
  }

  _escape(str) {
    return String(str).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]))
  }
}
